'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var collectionDom = exports.collectionDom = {
  navigationList: '[data-collection-nav]',
  navigationTitle: '[data-collection-nav-title]',

  productCount: '[data-products-displayed]',
  productLoadMore: '[data-load-more]',
  productWrapper: '[data-collection-product-content]',
  productVariantButton: '[data-product-variant-selector]',

  comingSoon: '[data-coming-soon-tag]',
  notifyMe: '[data-out-of-stock-tag]',
  atc: '[data-atc]',

  passToParent: '[data-pass-to-parent]',

  activeFiltersTitle: '[data-active-filters-title]',
  activeFilters: '[data-active-filters]',
  filterCount: '[data-filter-count]',
  stickyNav: '[data-sticky-nav]'
};

var collectionConstants = exports.collectionConstants = {
  updateFilters: 'PITVIPER.FILTERS.UPDATE'
};